import { jsxs as c, jsx as s } from "react/jsx-runtime";
import _ from "classnames";
import { ICONS_BY_TYPE as e } from "./constants.js";
import l from "../icon/Icon.js";
import '../../assets/Flag.css';const r = "_flag_46a8d_9", d = "_content_46a8d_22", f = "_informative_46a8d_35", g = "_attention_46a8d_39", u = "_critical_46a8d_43", p = "_small_46a8d_47", v = "_medium_46a8d_51", t = {
  flag: r,
  content: d,
  informative: f,
  attention: g,
  critical: u,
  small: p,
  medium: v
}, I = ({ children: i, title: n, size: a, type: o, className: m }) => /* @__PURE__ */ c("section", { className: _(t.flag, t[o], m, { [t[a]]: !!a }), children: [
  /* @__PURE__ */ s(l, { name: e[o] }),
  /* @__PURE__ */ c("div", { className: t.content, children: [
    !!n && /* @__PURE__ */ s("strong", { children: n }),
    i
  ] })
] });
export {
  I as default
};
